import { render, staticRenderFns } from "./UploadInput.vue?vue&type=template&id=5c42ae48&scoped=true"
import script from "./UploadInput.vue?vue&type=script&lang=js"
export * from "./UploadInput.vue?vue&type=script&lang=js"
import style0 from "./UploadInput.vue?vue&type=style&index=0&id=5c42ae48&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c42ae48",
  null
  
)

export default component.exports